class ForumEntryCreate
    constructor: (options) ->
        @.$el = null

        @.type = options?.type ? 'forum'

        @.actualTopic = options?.actualTopic ? false
        @.actualTopicText = options?.actualTopicText ? 'Aktuelles Thema'
        @.atText = options?.atText ? 'am'
        @.attrs = options?.attrs ? false
        @.buttonLink = options?.button?.link ? false
        @.buttonText = options?.button?.text ? (if @.type == 'forum' then 'Zum Forum' else 'Zum Thema')
        @.emptyText = options?.emptyText ? 'Noch keine Beiträge vorhanden'
        @.title = options?.title ? 'Foren-Eintrag'
        @.description = options?.description ? false
        @.lastPost = options?.lastPost ? false
        @.lastPostText = options?.lastPostText ? 'Letzter Beitrag'
        @.postsCount = options?.posts ? 0
        @.postsData = options?.postsData ? false
        @.postsDataAnswersText = options?.postsDataAnswerText ? 'Antworten'
        @.postsDataCreatedByText = options?.postsDataCreatedByText ? 'Erstellt von'
        @.postsText = options?.postsText ? 'Beiträge'
        @.topicsCount = options?.topics ? 0
        @.topicsText = options?.topicsText ? 'Themen'     

        @.CreateElement()
        
        if @.$el
            @.$el.classList.add 'forum-entry--bound'

        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement 'div'
        @.$el.classList.add 'forum-entry'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.innerHTML = "
            <div class='forum-entry__header'>
                <div class='forum-entry__header__left'>
                    <h3 class='headline headline--4 forum-entry__headline'>#{ @.title }</h3>
                    #{ if @.description then "<div class='forum-entry__header__description'>#{ @.description }</div>" else "" }
                    #{ if @.type == 'forum' then "
                        <div class='forum-entry__header__info'>
                            <div class='forum-entry__header__info__topics'>#{ @.topicsText }:<span>#{ @.topicsCount }</span></div>
                            <div class='forum-entry__header__info__posts'>#{ @.postsText }:<span>#{ @.postsCount }</span></div>
                        </div>
                        " else ""
                    }
                </div>
                <div class='forum-entry__header__right'>
                </div>
            </div>
            <div class='forum-entry__content'>
            </div>
        "
        @.$el.querySelector '.forum-entry__header__right'
            .appendChild new ButtonCreate {
                link: @.buttonLink,
                text: @.buttonText
            }
        if @.actualTopic
            @.$el.querySelector '.forum-entry__content'
                .innerHTML = "
                    <div class='forum-entry__content__topic'>#{ @.actualTopicText }:
                        #{ if @.actualTopic.link then "<a href='#{ @.actualTopic.link }'>#{ @.actualTopic.name ? 'Thema' }</a>" else "<span>#{ @.actualTopic.name ? 'Thema' }</span>" }
                    </div>
                "
        if @.postsData
            @.$el.querySelector '.forum-entry__content'
                .innerHTML += "
                    <div class='forum-entry__content__posts'>
                        <div class='forum-entry__content__posts__answers'>#{ @.postsDataAnswersText }:<span>#{ @.postsData?.answers ? 0 }</span></div>
                        <div class='forum-entry__content__posts__created-by'>#{ @.postsDataCreatedByText }:#{ if @.postsData?.createdByLink then "<a href='#{ @.postsData.createdByLink }'>#{ @.postsData?.createdBy ? 'Unbekannter Nutzer' }</a>" else "<span>#{ @.postsData?.createdBy ? 'Unbekannter Nutzer' }</span>" }</div>
                    </div>
                "
        if @.lastPost
            @.$el.querySelector '.forum-entry__content'
                .innerHTML += "
                    <div class='forum-entry__content__last-post'>
                    </div>
                "
            @.$el.querySelector '.forum-entry__content__last-post'
                .appendChild new ProfilePicCreate {
                    badge: @.lastPost.author?.badge ? false
                    pic: @.lastPost.author?.pic ? false
                    onWhite: true
                    small: true
                }
            @.$el.querySelector '.forum-entry__content__last-post'
                .innerHTML += "
                    <div class='forum-entry__content__last-post__info'>#{ @.lastPostText }:
                        <span>#{ @.lastPost.author?.name ? '' } #{ if @.lastPost.date then @.atText else "" } #{ @.lastPost.date ? '' }</span>
                    </div>
                "
        if !@.actualTopic && !@.lastPost
            @.$el.querySelector '.forum-entry__content'
                .innerHTML = "#{ @.emptyText }"
        return

window.CreateForumEntry = (options) ->
    return new ForumEntryCreate options